import React from 'react';
import TableHeaderRow from './TableHeaderRow';

const TableHeader = () => {
    return (
        <thead style={{ position: 'sticky', top: 0, zIndex: 999, backgroundColor: '#F7F7F7', boxShadow: "0px 3px 0px #707070" }}>
            <TableHeaderRow />
        </thead>
    )
}

export default TableHeader;